{
    "UI_Container_Title": "Impostazione completa del conto",
    "UI_Container_Description": "Inserite il vostro nome completo e una password per completare la registrazione.",
    "UI_Name_Placeholder": "Nome completo",
    "UI_Name_Label": "Nome completo",
    "UI_Password_Placeholder": "Password",
    "UI_Password_Label": "Password",
    "UI_PasswordLengthValidation": "La password è troppo corta",
    "UI_PasswordRequiredValidation": "La password non deve essere vuota",
    "UI_PasswordStrengthValidation": "La password non è abbastanza forte (assicurarsi di includere lettere maiuscole e minuscole e numeri).",
    "UI_Footer_Server_Error": "Errore del server",
    "UI_Footer_Submit_Button": "Invia",
    "UI_NameRequiredValidation": "Inserisci il tuo nome",
    "NAME": "UserInvite"
}